import React from 'react';

const TutorSettingMobile = () => {
    return (
        <div>
            TutorSettingMobile
        </div>
    );
};

export default TutorSettingMobile;